import axios from 'axios';

export default class Cart {
  constructor() {
    this.refs = {
      cartView: '.js-cartView',
      cartJson: '.js-cartJson',
      cartTotal: '.js-cartTotal',
      cartSubtotal: '.js-cartSubtotal',
      cartItemCount: '.js-cartItemCount',
      emptyCheckContainer: '.js-emptyCheckContainer',
      cartBody: '.js-cartBody',
    };

    this.dom = {
      $cartTotals: document.querySelectorAll(this.refs.cartTotal),
      $cartSubtotals: document.querySelectorAll(this.refs.cartSubtotal),
      $cartItemCounts: document.querySelectorAll(this.refs.cartItemCount),
      $emptyCheckContainers: document.querySelectorAll(this.refs.emptyCheckContainer),
      $cartBodies: document.querySelectorAll(this.refs.cartBody),
    };

    this.state = {
      html: null,
      json: null,
      emptyClass: 'is-empty',
      mountCartItemsEvent: 'mountcartitems',
      mountCartItemsTotals: 'mountcarttotals',
      openCartDrawerEvent: 'opencartdrawer',
    };
  }

  async addItem(id, properties = {}, quantity = 1, openMiniCart = true) {
    const { state } = this;
    const itemData = {
      items: [{
        id,
        quantity,
        properties,
      }],
    };

    try {
      await axios.post('/cart/add.js', itemData);
      await this.getUpdatedCart();
      this.handlePreUpdateHooks();

      if (openMiniCart) {
        document.dispatchEvent(new Event(state.openCartDrawerEvent));
      }
    } catch (e) {
      console.log('Error adding product to cart', e);
    }
  }

  async addSubscriptionItem(id, properties, sellingPlanId, quantity = 1) {
    const { state } = this;
    const itemData = {
      items: [{
        id,
        quantity,
        selling_plan: sellingPlanId,
        properties,
      }],
    };

    try {
      await axios.post('/cart/add.js', itemData);
      await this.getUpdatedCart();
      this.handlePreUpdateHooks();
      document.dispatchEvent(new Event(state.openCartDrawerEvent));
    } catch (e) {
      console.log('Error adding product to cart', e);
    }
  }

  async updateSubscription(line, sellingPlan, quantity) {
    const updates = {
      line,
      quantity,
      selling_plan: sellingPlan,
    };

    try {
      await axios.post('/cart/change.js', updates);
      await this.getUpdatedCart();
      this.handlePreUpdateHooks();
    } catch (e) {
      console.log('Error updating cart item', e);
    }
  }

  async addItems(items) {
    const data = {
      items,
    };

    try {
      await axios.post('/cart/add.js', data);
      await this.getUpdatedCart();
      this.handlePreUpdateHooks();
    } catch (e) {
      console.log('Error adding products to cart', e);
    }
  }

  async updateItem(key, quantity) {
    const updates = {};
    updates[key] = quantity;

    try {
      await axios.post('/cart/update.js', { updates });
      await this.getUpdatedCart();
      this.handlePreUpdateHooks();
    } catch (e) {
      console.log('Error updating cart item', e);
    }
  }

  async updateItems(updates) {
    try {
      await axios.post('/cart/update.js', { updates });
      await this.getUpdatedCart();
      this.handlePreUpdateHooks();
    } catch (e) {
      console.log('Error updating cart item', e);
    }
  }

  async getUpdatedCart() {
    const { state, refs } = this;

    try {
      const res = await axios.get('/cart');
      const parser = new DOMParser();
      const html = parser.parseFromString(res.data, 'text/html');
      state.html = html.querySelector(refs.cartView);
      state.json = JSON.parse(html.querySelector(refs.cartJson).innerHTML);
    } catch (e) {
      console.log('Error fetching updated cart page', e);
    }
  }

  handlePreUpdateHooks() {
    const { state: { html, json } } = this;

    this.updateCartBody(html);
    this.updateCartTotals(html);
    this.updateCartCounts(json.item_count);
    this.updateEmptyStates(json.item_count);
  }

  updateCartBody(html) {
    const { dom, state, refs } = this;

    const updatedCartBody = html.querySelector(refs.cartBody).innerHTML;
    dom.$cartBodies.forEach((elem) => { elem.innerHTML = updatedCartBody; });
    document.dispatchEvent(new Event(state.mountCartItemsEvent));
  }

  updateCartTotals(html) {
    const { dom, refs, state } = this;

    const total = html.querySelector(refs.cartTotal).textContent;
    dom.$cartTotals.forEach((elem) => { elem.textContent = total; });

    const subtotal = html.querySelector(refs.cartSubtotal).textContent;
    dom.$cartSubtotals.forEach((elem) => { elem.textContent = subtotal; });

    document.dispatchEvent(new Event(state.mountCartItemsTotals));
  }

  updateCartCounts(count) {
    const { dom } = this;
    dom.$cartItemCounts.forEach((elem) => { elem.textContent = count; });
  }

  updateEmptyStates(count) {
    const { dom, state } = this;

    if (count > 0) {
      dom.$emptyCheckContainers.forEach((elem) => elem.classList.remove(state.emptyClass));
    } else {
      dom.$emptyCheckContainers.forEach((elem) => elem.classList.add(state.emptyClass));
    }
  }
}
